/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * User Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User group scheme
 * @export
 * @interface UserGroup
 */
export interface UserGroup {
    /**
     * @type {string}
     * @memberof UserGroup
     */
    name: string;
    /**
     * @type {string}
     * @memberof UserGroup
     */
    address?: string;
    /**
     * @type {string}
     * @memberof UserGroup
     */
    phone_number?: string;
    /**
     * @type {number}
     * @memberof UserGroup
     */
    id: number;
    /**
     * @type {number}
     * @memberof UserGroup
     */
    client_access_code?: number;
}
